import { http } from "@common";
import endpoint from "../endpoint_cis";

export default {
    login: (data) => {
        return http.get(endpoint.account.login, data);
    },
    changePassword: () => {
        return http.get(endpoint.account.change_password);
    },
    getUserProfile: () => {
        return http.get(endpoint.account.get_user_profile);
    },
    logout: () => {
        return http.get(endpoint.account.logout);
    },
    getUserInfo: () => {
        return http.get(endpoint.account.get_user_info);
    },
    regoLogin: (redirectUri = '', idp_hint = '') => {
        return http.get(endpoint.account.rego_login, redirectUri ? { 'redirect_uri': encodeURIComponent(redirectUri), 'idp_hint': idp_hint } : { 'idp_hint': idp_hint });
    },
    getCurrentUser: () => {
        return http.get(endpoint.account.get_current_user);
    },
    logoutIDP: () => {
        return http.get(endpoint.account.logout_idp);
    },
    goToChangePassword: (params) => {
        return http.post(endpoint.account.go_to_change_password, params);
    }
};